import React, { useEffect, useState } from "react"
import { generateUniqueId } from "../../utils/helpers"

export interface TabButton {
    id?: string,
    content: React.ReactNode
}

export interface TabsProps {
    id?: string,
    buttons: TabButton[],
    children?: React.ReactNode[],
    onChange?: (selectedTabId: any) => void,
    buttonClass?: string,
    defaultActiveTabIndex?: number
}
const Tabs: React.FC<TabsProps> = ({ id = generateUniqueId(), buttons, onChange, children, buttonClass = '', defaultActiveTabIndex=0}) => {

    const [activeTab, setActiveTab] = useState<number>(defaultActiveTabIndex)

    useEffect(() => {
        if (onChange) {
            onChange(buttons[activeTab]?.id);
        }
    }, [activeTab])

    return (
        <React.Fragment>
            <div className={`tab-controls tabs-small tabs-rounded ${buttonClass}`} id={id}>
                {
                    buttons.map((btn, i) => {
                        return (
                            <a onClick={e => setActiveTab(i)} className={`no-effect d-flex align-items-center cursor-pointer justify-content-center gap-2 ${activeTab === i && 'bg-highlight'}`} key={i}>{btn.content}</a>
                        )
                    })
                }

            </div>
            <div className="clearfix mb-3"></div>
            {
                children && children.map((child, i) => {
                    return (
                        <div className={`collapse ${activeTab === i && 'show'}`} key={i}>
                            {child}
                        </div>
                    )
                })
            }
        </React.Fragment>
    )
}

export default Tabs